import { updateProjectLimitedDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateProjectLimitedCallable = getCallable(
  updateProjectLimitedDefinition,
);
